import { Col,Row, Space, Typography } from 'antd';
import { Select } from 'antd';
import { Radio } from 'antd';
import AntButton from '../AntButton/AntButton';
import useAntFilter from './useAntFilter';




const PopoverContent = ({fields,getData,getFilterStatus}) => {
  const  {
    renderFilterOptions,
    onChangeType,
    filteredOptions,
    setSelectedItems,
    selectedItems,
    typeOfFilter,
    type,
    apply,
    reset

  } = useAntFilter({fields,getData,getFilterStatus})

  return (
    <div style={{ maxWidth: '500px' }}>
      <Row gutter={[6, 6]}>
        <Col span={24}><Typography>Select Fields for filter</Typography></Col>
        <Col span={24}>
          <Select
            mode="multiple"
            placeholder="Select fields"
            value={selectedItems}
            onChange={setSelectedItems}
            style={{ width: '100%' }}
            options={filteredOptions.map((item) => ({
              value: item,
              label: item,
            }))}
          />
        </Col>
        <Col span={24}><Typography>Select Type of filter</Typography></Col>
        <Col span={24}>
          <Radio.Group options={typeOfFilter} onChange={onChangeType} value={type} optionType="button" />
        </Col>
        {renderFilterOptions()}
        <Col span={24}>
          <Space style={{ float: 'right', margin: '2%' }}>
            <AntButton type='default' text='Reset' onClick={reset}/>
            <AntButton type='primary' text='Apply' color={"#185993"} onClick={apply}/>
          </Space>
        </Col>
      </Row>
    </div>
  );
};

export default PopoverContent;
